/**
 * Shared CSS class strings and animation props for context/dropdown menus
 * Used by SectionList (left sidebar) and RightSidebar menus
 */

/** Base class for enabled menu items */
export const MENU_ITEM_CLASS =
  "relative flex w-full cursor-default select-none items-center gap-2 whitespace-nowrap rounded-sm px-2 py-1.5 text-sm font-medium outline-none transition-colors hover:bg-gray-100 hover:text-gray-900";

/** Base class for disabled menu items */
export const DISABLED_MENU_ITEM_CLASS =
  "relative flex w-full cursor-not-allowed select-none items-center gap-2 whitespace-nowrap rounded-sm px-2 py-1.5 text-sm font-medium text-gray-300 outline-none";

/** Base class for destructive (delete) menu items */
export const DESTRUCTIVE_MENU_ITEM_CLASS =
  "relative flex w-full cursor-default select-none items-center gap-2 whitespace-nowrap rounded-sm px-2 py-1.5 text-sm font-medium text-red-500 outline-none transition-colors hover:bg-red-50 hover:text-red-600";

/** Shared framer-motion animation props for dropdown/context menus */
export const MENU_ANIMATION_PROPS = {
  initial: { opacity: 0, scale: 0.95, y: -4 },
  animate: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.95, y: -4 },
  transition: { duration: 0.15 },
} as const;
